import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import Picker from '../../core/components/Picker'
import {queryActivityRef} from '../actions'

class ActivityPicker extends Component {
    static propTypes = {
    }

    componentWillMount() {
        const {dispatch} = this.props
        dispatch(queryActivityRef())
    }

    render() {
        const {reference, ...others} = this.props

        const displayActivity = (activity, mode) => {
            if (mode == 'Picked') {
                return (
                    <h4>{activity.label}</h4>
                )
            }
            return activity.label
        }

        return (
            <Picker
                source={reference}
                identify={(a) => a.uid}
                display={displayActivity}
                {...others} />
        )
    }
}

ActivityPicker = connect((state) => ({
    reference: state.reference.activityRef
}))(ActivityPicker)

export default ActivityPicker


// WEBPACK FOOTER //
// ./lib/reference/components/ActivityPicker.js